import React from 'react'

const importAll = (requireContext: __WebpackModuleApi.RequireContext) =>
  requireContext.keys().forEach(requireContext)
try {
  importAll(require.context('../../assets/svg/task', true, /\.svg$/))
} catch (error) {}

// require('../svg/diwei.svg')
type Props = {
  name: string
} & React.SVGAttributes<SVGElement>

export const SvgIconTask = ({ name, ...props }: Props) => (
  <svg {...props}>
    <use xlinkHref={`#${name}`} />
  </svg>
)
